import styled, { css } from 'styled-components';
import {
    Text,
    spaceMixin,
    mediaMixin,
    token,
    IconCheckmark,
} from '@zillow/constellation';

export const StyledDesktopText = styled(Text)`
    font-weight: ${props => (props.isBold ? '700' : '400')};
    text-align: center;
    display: none;

    ${mediaMixin('md', css`
        padding-top: ${spaceMixin('xs')};
        display: block;
    `)};
`;

export const StyledIconCheckmark = styled(IconCheckmark)`
    && {
        height: 14px;
        width: 14px;
    }
`;

export const StyledStepContainer = styled.div`
    z-index: 2;
    border-radius: 50%;
    border: 8px solid ${props => (props.isActive ? 'rgba(7, 77, 255, 0.1)' : 'transparent')};
`;

export const StyledStep = styled.div`
    border-radius: 50%;
    border-width: 5px;
    border-style: solid;
    height: ${spaceMixin('md')};
    width: ${spaceMixin('md')};
    color: ${token('colors.white')};
`;

export const StyledCustomStep = styled(StyledStep)`
    && {
        border-color: ${props => props.borderColor};
        background-color: ${props => props.backgroundColor};
    }
`;

export const StyledActiveStep = styled(StyledStep)`
    && {
        border-color: ${token('colors.white')};
        background-color: ${token('colors.brand')};
        box-shadow: 0px 2px 4px rgba(33, 29, 29, 0.2);
    }
`;
